require("core-js/modules/es.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.xiazengRouter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var xiazeng = {
    path: '/xiazeng',
    redirect: '/xiazeng/index',
    name: 'Xiazeng',
    component: function component() {
      return import('@/Layout');
    },
    meta: {
      title: '虾罾质检'
    },
    children: [{
      path: 'index',
      component: function component() {
        return import('@/pages/xiazeng/index');
      },
      name: 'XiazengIndex',
      meta: {
        title: '生产工具'
      }
    }, {
      path: 'deviceTestList',
      component: function component() {
        return import('@/pages/xiazeng/deviceTestList');
      },
      name: 'XiazengDeviceTestList',
      meta: {
        title: '设备列表'
      }
    }, {
      path: 'deviceTestDetail',
      component: function component() {
        return import('@/pages/xiazeng/deviceTestDetail');
      },
      name: 'XiazengDeviceTestDetail',
      meta: {
        title: '测试详情'
      }
    }, {
      path: 'login',
      component: function component() {
        return import('@/pages/xiazeng/login');
      },
      name: 'XiazengLogin',
      meta: {
        title: '登录'
      }
    }, {
      path: 'checkList',
      component: function component() {
        return import('@/pages/xiazeng/checkList');
      },
      name: 'XiazengCheckList',
      meta: {
        title: '待质检列表'
      }
    }, {
      path: 'qaEngine',
      component: function component() {
        return import('@/pages/xiazeng/qaEngine');
      },
      name: 'XiazengQaEngine',
      meta: {
        title: '质检详情'
      }
    }, {
      path: 'qaDetail',
      component: function component() {
        return import('@/pages/xiazeng/qaDetail');
      },
      name: 'XiazengQaDetail',
      meta: {
        title: '质检详情'
      }
    }, {
      path: 'qaHistory',
      component: function component() {
        return import('@/pages/xiazeng/qaHistory');
      },
      name: 'XiazengQaHistory',
      meta: {
        title: '质检记录'
      }
    }, {
      path: 'manualInput',
      component: function component() {
        return import('@/pages/xiazeng/manualInput');
      },
      name: 'XiazengManualInput',
      meta: {
        title: '手动输入编号'
      }
    }, {
      path: 'barcodeBindList',
      component: function component() {
        return import('@/pages/xiazeng/barcodeBindList');
      },
      name: 'XiazengBarcodeBindList',
      meta: {
        title: '关联条形码'
      }
    }, {
      path: 'barcodeBindRecord',
      component: function component() {
        return import('@/pages/xiazeng/barcodeBindRecord');
      },
      name: 'XiazengBarcodeBindRecord',
      meta: {
        title: '关联记录'
      }
    }]
  };
  var _default = xiazeng;
  _exports.default = _default;
});